module.exports = __webpack_public_path__ + "edfad27a6aacdd86888e2470c45c20c8.jpg";